'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = require('../../../inputs/Select');

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SelectCondition(props) {
  var linkState = props.linkState,
      schema = props.schema,
      style = props.style;

  return _react2.default.createElement(
    'div',
    { className: style.searchWidget },
    _react2.default.createElement(
      'div',
      { className: style['ref-container'] },
      _react2.default.createElement(_Select2.default, _extends({
        multi: true,
        schema: schema
      }, linkState('selecteds')))
    )
  );
}

var func = _propTypes2.default.func,
    object = _propTypes2.default.object;

SelectCondition.propTypes = {
  linkState: func.isRequired,
  schema: object.isRequired,
  style: object.isRequired
};

SelectCondition.buildQuery = function buildSelectQuery(_ref) {
  var selecteds = _ref.selecteds;

  if (!selecteds || selecteds.length === 0) return null;

  if (_typeof(selecteds[0]) === 'object' && selecteds[0]._id) {
    return { $in: selecteds.map(function (v) {
        return 'ObjectId(\'' + v._id + '\')';
      }) };
  }
  return { $in: selecteds };
};

exports.default = SelectCondition;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/DocList/QueryEditor/ConditionEditor/SelectCondition.js
// module id = 1700
// module chunks = 0